
import { defineComponent, ComputedRef, ref, Ref, computed, onMounted, reactive, watch, toRefs, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { useRoute } from 'vue-router'
import { message, Form } from 'ant-design-vue'
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import { freightInfoType, freightDataType } from './data'
import {StateType as DestinationStateType} from '@/store/destination'
import {StateType as AreaStateType} from '@/store/area'
import { StateType as FreightType} from './store'
import {StateType as UserOrderDataListType} from '../../../home/store'
import { keepTwoNum, twoFloat } from "@/utils/number";
import { arealistFn } from '@/utils/array'
import { AreaParams } from '@/services/data.d'
import router from '@/config/routes'
const useForm = Form.useForm;
interface CalculationData {
    modelRef: freightInfoType;
    validateInfos: ComputedRef<validateInfos>;
    countrylist:Ref<any>;
    countrylistSet:Ref<any>;
    arealist: Ref<any[]>;
    freightCalculationDataInfoList: freightDataType;
    isFlag: Ref<boolean>;
    newArealist: Ref<any[]>
    filterOption: (input:string,option:any) => any;
    handleSelectDes: (e: MouseEvent) => void;
    postFromData: (e: MouseEvent)=> void;
    handleChangeForever: (val:any) => void;
    handleRest: (e: MouseEvent) => void;
    submitLoading: Ref<boolean>;
    numAdd: (num1,num2) => string;
    handleDeliveryType: (e: MouseEvent) => void;
}
export default defineComponent({
    name: 'freightcalculation',
    props:['destination','city','pickupWay'],
    setup(props):CalculationData{
        const countrylist = ref<any>([])
        const countrylistSet = ref<any>([])
        const arealist = ref<any[]>([])
        const isFlag = ref<boolean>(false)
        const newArealist = ref<any[]>([])
        const route = useRoute()
        const store = useStore<{
            destination:DestinationStateType,
            area:AreaStateType,
            freightcalculation:FreightType,
            Home: UserOrderDataListType
        }>()
        const queryInfo = JSON.parse(localStorage.getItem('initconfig') as string)
        // console.log('queryInfo',JSON.parse(localStorage.getItem('initconfig') as string))
        const modelRef = reactive<freightInfoType>({
            countryEn:'',
            productType:'1', //产品类型
            destination: '', //目的国二字码
            city: queryInfo ? queryInfo.cityName : '',    //揽收城市
            deliveryType: queryInfo ? queryInfo.pickupWay+'' : '',    //揽收方式
            weightVal:'',      //包裹重量
            length:'',  //长
            width:'',   //宽
            height:'',  //高
            flag: false, //体积重试算
        })


        const freightCalculationDataInfoList = reactive<freightDataType>({
            calcParam: 0,
            bubbleRatio: 0,
            calculationBubbleRatio: 0,
            checkParam: 0,
            weightPrice: 0,
            unitPrice: 0,
            priceUnit: 0,
            diversityWeightPrice: 0,
            diversityUnitPrice: 0,
            remarks: '',
            actualPrice: 0,
            volumeWeightPrice: 0,
            bubbleCalc: '',
            billingPrice: 0,
            volumeWeight: 0,
            weight:0,
            bulkWeightPrice:0,
            bulkUnitPrice: 0,
            bulkDiversityWeightPrice: 0,
            bulkDiversityUnitPrice:0,
            bulkFlag: false
        })

        const rulesRef = reactive({
            countryEn:[],
            productType:[{
                required: true,
                message: '请选择产品类型'
            }],
            destination:[{
                required: true,
                message: '请选择目的国名称'
            }],
            city:[{
                required: true,
                message: '请选择城市'
            }],
            deliveryType:[{
                required: true,
                message: '请选择揽收方式'
            }],
            weightVal:[{
                required: true,
                message: '请输入包裹重量'
            }],
            length:[{
                required: false,
                message: '请输入长宽高'
            }],
            width:[{
                required: false,
                message: '请输入宽'
            }],
            height:[{
                required: false,
                message: '请输入高'
            }],
            flag:[]
        })
        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)

        //获取国家-国籍
        const filterOption = (input: string, option: any) => {
            return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
        //选择目的国后国家是英文
        const handleSelectDes = (e: MouseEvent) => {
            modelRef.countryEn = modelRef.destination
        }

        const countryName = async() => {
            try {
                const params = {}
                const res: boolean = await store.dispatch('destination/getDestinationFn',params)
                if(res===true){
                  countrylist.value = store.state.destination.destinationList
                  const res = new Map();
                  countrylistSet.value = countrylist.value.filter((arr:any) => !res.has(arr.name) && res.set(arr.name, 1));
                //   console.log('countrylistSet.value',countrylistSet.value)
                  countrylistSet.value.filter((item:any) => {
                    if(item.name == queryInfo.destination){
                        modelRef.destination = item.code
                    }
                  })
                }
            } catch (error) {
                message.warning('获取国家失败!')
            }
        }

        //获取地址
        const areaListInitFn = async(params:AreaParams) => {
            try {
                const res:boolean = await store.dispatch('area/getAreaFn', params)
                if(res){
                    arealist.value = arealistFn(store.state.area.arealist,1)
                }
            } catch (error) {
                message.warning('获取地区信息失败!')
            }
        }

        
        // 计算
        const submitLoading = ref<boolean>(false);
        const postFromData = async(e: MouseEvent) => {
            freightCalculationDataInfoList.calcParam = 0
            freightCalculationDataInfoList.bubbleRatio = 0
            freightCalculationDataInfoList.calculationBubbleRatio = 0
            freightCalculationDataInfoList.checkParam = 0
            freightCalculationDataInfoList.weightPrice = 0
            freightCalculationDataInfoList.unitPrice = 0
            freightCalculationDataInfoList.priceUnit = 0
            freightCalculationDataInfoList.diversityWeightPrice = 0
            freightCalculationDataInfoList.diversityUnitPrice = 0
            freightCalculationDataInfoList.remarks = ''
            freightCalculationDataInfoList.actualPrice = 0
            freightCalculationDataInfoList.volumeWeightPrice = 0
            freightCalculationDataInfoList.bubbleCalc = ''
            freightCalculationDataInfoList.billingPrice = 0
            freightCalculationDataInfoList.volumeWeight = 0
            freightCalculationDataInfoList.weight = 0
            freightCalculationDataInfoList.bulkWeightPrice = 0
            freightCalculationDataInfoList.bulkUnitPrice = 0
            freightCalculationDataInfoList.bulkDiversityWeightPrice = 0
            freightCalculationDataInfoList.bulkDiversityUnitPrice = 0
            freightCalculationDataInfoList.bulkFlag = false
            freightCalculationDataInfoList.billingPrice = 0
            try {
                debugger;
                submitLoading.value = true;
                const fieldsValue = await validate<freightInfoType>()
                let l = Number(fieldsValue.length);
                let w = Number(fieldsValue.width);
                let h = Number(fieldsValue.height);
                if(fieldsValue.flag && (l + (w+h)) * 2 > 300){
                    modelRef.flag = true
                    // isFlag.value = true
                    submitLoading.value = false;
                    message.warning('包裹尺寸范围限制：长+(宽+高)x2≤300cm')
                    return false
                }
                const params = {
                    productType: fieldsValue.productType,
                    destination: fieldsValue.destination.split('|')[0],
                    city: fieldsValue.city,
                    deliveryType: fieldsValue.deliveryType,
                    weightVal: fieldsValue.weightVal,
                    length: fieldsValue.flag ? fieldsValue.length : '',
                    width: fieldsValue.flag ? fieldsValue.width : '',
                    height: fieldsValue.flag ? fieldsValue.height : '',
                    flag: fieldsValue.flag
                }
                const res: boolean = await store.dispatch('freightcalculation/getFreightFn',params)
                if(res===true){
                    const { calcParam, bubbleRatio, calculationBubbleRatio, checkParam, weightPrice, unitPrice, priceUnit, diversityWeightPrice, diversityUnitPrice, remarks, actualPrice, volumeWeightPrice, bubbleCalc, billingPrice, volumeWeight, weight, bulkWeightPrice,bulkUnitPrice,bulkDiversityWeightPrice,bulkDiversityUnitPrice,bulkFlag,
 } = store.state.freightcalculation.getFreightInfo
                    if(checkParam===null||checkParam==0){
                        isFlag.value=false;
                    }else{
                        isFlag.value=true;
                    }
                    freightCalculationDataInfoList.calcParam = calcParam
                    freightCalculationDataInfoList.calcParam = calcParam
                    freightCalculationDataInfoList.bubbleRatio = (bubbleRatio)
                    freightCalculationDataInfoList.calculationBubbleRatio = calculationBubbleRatio!=null?twoFloat(calculationBubbleRatio):0
                    freightCalculationDataInfoList.checkParam = checkParam || 0
                    freightCalculationDataInfoList.weightPrice =  (weightPrice)
                    freightCalculationDataInfoList.unitPrice = (unitPrice)
                    freightCalculationDataInfoList.priceUnit = (priceUnit)
                    freightCalculationDataInfoList.diversityWeightPrice = diversityWeightPrice
                    freightCalculationDataInfoList.diversityUnitPrice = diversityUnitPrice
                    freightCalculationDataInfoList.remarks = remarks
                    freightCalculationDataInfoList.actualPrice = twoFloat(actualPrice)
                    freightCalculationDataInfoList.volumeWeightPrice = twoFloat(volumeWeightPrice)
                    freightCalculationDataInfoList.bubbleCalc = bubbleCalc
                    freightCalculationDataInfoList.volumeWeight = volumeWeight
                    freightCalculationDataInfoList.weight = weight
                    freightCalculationDataInfoList.bulkWeightPrice = (bulkWeightPrice)
                    freightCalculationDataInfoList.bulkUnitPrice = (bulkUnitPrice)
                    freightCalculationDataInfoList.bulkDiversityWeightPrice = (bulkDiversityWeightPrice)
                    freightCalculationDataInfoList.bulkDiversityUnitPrice = (bulkDiversityUnitPrice)
                    freightCalculationDataInfoList.bulkFlag = bulkFlag
                    if(freightCalculationDataInfoList.bulkFlag){
                      freightCalculationDataInfoList.billingPrice = twoFloat(volumeWeightPrice);
                    }else{
                      freightCalculationDataInfoList.billingPrice =twoFloat(actualPrice);
                    }
                }
            }catch(error){
                console.log(error)
            }
            submitLoading.value = false;
        }

        //重置
        const handleRest = (e: MouseEvent) => {
            e.preventDefault()
            resetFields()
            countryName()
            freightCalculationDataInfoList.calcParam = 0
            freightCalculationDataInfoList.bubbleRatio = 0
            freightCalculationDataInfoList.calculationBubbleRatio = 0
            freightCalculationDataInfoList.checkParam = 0
            freightCalculationDataInfoList.weightPrice = 0
            freightCalculationDataInfoList.unitPrice = 0
            freightCalculationDataInfoList.priceUnit = 0
            freightCalculationDataInfoList.diversityWeightPrice = 0
            freightCalculationDataInfoList.diversityUnitPrice = 0
            freightCalculationDataInfoList.remarks = ''
            freightCalculationDataInfoList.actualPrice = 0
            freightCalculationDataInfoList.volumeWeightPrice = 0
            freightCalculationDataInfoList.bubbleCalc = ''
            freightCalculationDataInfoList.billingPrice = 0
            freightCalculationDataInfoList.volumeWeight = 0
            freightCalculationDataInfoList.weight = 0
            freightCalculationDataInfoList.bulkWeightPrice = 0
            freightCalculationDataInfoList.bulkUnitPrice = 0
            freightCalculationDataInfoList.bulkDiversityWeightPrice = 0
            freightCalculationDataInfoList.bulkDiversityUnitPrice = 0
            freightCalculationDataInfoList.bulkFlag = false
            freightCalculationDataInfoList.billingPrice = 0
        }

        const handleChangeForever = (val: any) => {
            if(val.target.checked){
                rulesRef.length[0].required = true
                rulesRef.width[0].required = true
                rulesRef.height[0].required = true
                modelRef.flag = true
                // isFlag.value = true
            }else{
                rulesRef.length[0].required = false
                rulesRef.width[0].required = false
                rulesRef.height[0].required = false
                modelRef.flag = false
                // isFlag.value = false
            }
        }

        const init = () => {
            countryName()
            if(queryInfo.pickupWay == 1){
                newArealist.value = localStorage.getItem('pickupScopeList') && JSON.parse(String(localStorage.getItem('pickupScopeList')))
            }else{
                const newArea = localStorage.getItem('stationAreaList') && JSON.parse(String(localStorage.getItem('stationAreaList')))
                const arrList = [] as any
                newArea.map((item:any) => {
                    item.children.map((tag:any) => {
                        delete tag.children
                        tag.id = tag.value
                        tag.city = tag.label
                        arrList.push(tag)
                    })
                })
                newArealist.value = arrList
                console.log('arrList',arrList)
            }
            console.log(newArealist.value,queryInfo)
            // areaListInitFn({countryCode: '156'})
        }
        //加法运算
        const numAdd=(num1, num2):string=> {
            var baseNum, baseNum1, baseNum2
            try {
                baseNum1 = num1.toString().split('.')[1].length
            } catch (e) {
                baseNum1 = 0
            }
            try {
                baseNum2 = num2.toString().split('.')[1].length
            } catch (e) {
                baseNum2 = 0
            }
            baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
            var precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2 //精度
            return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision)
        }



        const handleDeliveryType = (e: MouseEvent) => {
            newArealist.value = []
            if(modelRef.deliveryType == 1){
                newArealist.value = localStorage.getItem('pickupScopeList') && JSON.parse(String(localStorage.getItem('pickupScopeList')))
            }else{
                const newArea = localStorage.getItem('stationAreaList') && JSON.parse(String(localStorage.getItem('stationAreaList')))
                const arrList = [] as any
                newArea.map((item:any) => {
                    item.children.map((tag:any) => {
                        delete tag.children
                        tag.id = tag.value
                        tag.city = tag.label
                        arrList.push(tag)
                    })
                })
                newArealist.value = arrList
                console.log('arrList',arrList)
            }
        }

        onMounted(()=>{
            init()
        })

        return {
            filterOption,
            handleSelectDes,
            modelRef,
            validateInfos: validateInfosNew,
            countrylist,
            countrylistSet,
            arealist,
            isFlag,
            postFromData,
            handleChangeForever,
            freightCalculationDataInfoList,
            submitLoading,
            handleRest,
            newArealist,
            numAdd,
            handleDeliveryType
        }
    }
})
